import './EditBay.scss';
import PropTypes from 'prop-types';
import BayList from '../BayList/BayList';
import Packages from '../../api/controllers/Packages/Packages';
import { useEffect, useState } from 'react';
import Error from '../../common/Error/Error';

// EditBay Component
const EditBay = ({
  packages,
  refetchPackages,
  setModalOpen,
  bays,
  racks,
  overrideHandleClick,
  overrideError,
}) => {
  const [error, setError] = useState();

  const setPackageBay = bay => {
    const ids = packages.map(p => p.package.id);
    const data = { bayId: bay == 'none' ? null : bay.id };

    Packages.update(ids, data)
      .then(() => {
        refetchPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const handleClick = bay => {
    if (packages) {
      setPackageBay(bay);
    } else {
      overrideHandleClick(bay);
    }
  };

  useEffect(() => {
    setError(overrideError);
  }, [overrideError]);

  return (
    <div className="edit_package_bay_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${
                  error.length > 1 ? 's' : ''
                } prohibited this item from being saved: `
              : ''
          }
        />
      )}
      {packages && (
        <div className="affected_packages">
          {packages.length > 0 &&
            `This action applies to ${
              packages.length > 3
                ? `${packages.length} packages`
                : `${packages[0].packageName}${
                    packages[1]
                      ? `${packages.length > 2 ? ',' : ' and'} ${packages[1].packageName}`
                      : ''
                  }${packages[2] ? ` and ${packages[2].packageName}` : ''}`
            } `}
        </div>
      )}
      <BayList handleClick={handleClick} bays={bays} racks={racks} />
    </div>
  );
};

EditBay.propTypes = {
  packages: PropTypes.array,
  setModalOpen: PropTypes.func,
  overrideHandleClick: PropTypes.func,
  refetchPackages: PropTypes.func,
  bays: PropTypes.array,
  racks: PropTypes.object,
  overrideError: PropTypes.array,
};

export default EditBay;
